import { useMemo } from 'preact/hooks'

export const useSwatches = ({
    variantColors,
    variantImages,
    fallbackImage,
    swatchOptions1,
    productUrl
}) => {
    return useMemo(() => {
        if (!variantColors) {
            return []
        } else {
            let swatchList = new Set();
            const variantColorsArray = typeof(variantColors) === 'object' ? variantColors : variantColors.split("|");
            variantColorsArray.forEach(color => {
              let colorSwatches = Object.assign({}, swatchOptions1);
              let swatch = new Object();

              swatch.color = color.trim();
              swatch.fallback_img = fallbackImage;
              swatch.productUrl = productUrl

              variantImages.forEach(function (img, index) {
                  if (img.color.replace(/\s+/g, ' ').trim() == swatch.color.replace(/\s+/g, ' ').trim()) {
                       swatch.thumbnail = img.img;
                   }
                })

                if (colorSwatches[swatch.color]) {
                  swatch.swatch_options = colorSwatches[swatch.color]
                } else {
                    swatch.swatch_options = {};
                }
                swatchList.add(swatch);
            });
            return swatchList;
        }
    }, [
        variantColors,
        variantImages,
        fallbackImage,
        swatchOptions1,
        productUrl
    ])
}
